import { useState } from "react";

const inputCls = "w-full px-3 py-2 rounded-md border border-[var(--aria-border)] bg-[var(--aria-bg)] outline-none focus:ring-2 focus:ring-[var(--aria-primary)] text-sm";
const toLocal = (iso) => (iso ? new Date(iso).toISOString().slice(0, 16) : "");
const toIso = (local) => (local ? new Date(local).toISOString() : null);

export function ApplicationForm({ initial, types, statuses, onSave, onCancel }) {
  const [f, setF] = useState({
    title: initial?.title || "", institution: initial?.institution || "", type: initial?.type || "phd",
    status: initial?.status || "researching", deadline: toLocal(initial?.deadline), interview_date: toLocal(initial?.interview_date),
    link: initial?.link || "", contact: initial?.contact || "", notes: initial?.notes || "",
  });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = () => {
    if (!f.title.trim()) return;
    onSave({ ...f, deadline: toIso(f.deadline), interview_date: toIso(f.interview_date), link: f.link || null, contact: f.contact || null });
  };
  return (
    <div className="aria-card p-5 mb-6 space-y-3" data-testid="application-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <input value={f.title} onChange={set("title")} placeholder="Program / role (e.g. Postdoc — Biophysics)" data-testid="application-title-input" className={inputCls} />
        <input value={f.institution} onChange={set("institution")} placeholder="Institution" data-testid="application-institution-input" className={inputCls} />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <select value={f.type} onChange={set("type")} data-testid="application-type-select" className={inputCls}>{types.map(t => <option key={t} value={t}>{t}</option>)}</select>
        <select value={f.status} onChange={set("status")} data-testid="application-status-select" className={inputCls}>{statuses.map(s => <option key={s} value={s}>{s}</option>)}</select>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><label className="text-xs text-[var(--aria-text-muted)]">Application deadline</label>
          <input type="datetime-local" value={f.deadline} onChange={set("deadline")} data-testid="application-deadline-input" className={inputCls} /></div>
        <div><label className="text-xs text-[var(--aria-text-muted)]">Interview date</label>
          <input type="datetime-local" value={f.interview_date} onChange={set("interview_date")} data-testid="application-interview-input" className={inputCls} /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <input value={f.link} onChange={set("link")} placeholder="Posting URL" data-testid="application-link-input" className={inputCls} />
        <input value={f.contact} onChange={set("contact")} placeholder="Contact / PI (name or email)" data-testid="application-contact-input" className={inputCls} />
      </div>
      <textarea value={f.notes} onChange={set("notes")} rows={2} placeholder="Notes" data-testid="application-notes-input" className={inputCls} />
      <div className="flex justify-end gap-2">
        <button onClick={onCancel} data-testid="application-cancel-button" className="px-4 py-2 text-sm rounded-md border border-[var(--aria-border)]">Cancel</button>
        <button onClick={submit} disabled={!f.title.trim()} data-testid="application-save-button" className="btn btn-primary px-4 py-2 text-sm disabled:opacity-50">{initial ? "Save" : "Add"}</button>
      </div>
    </div>
  );
}
